const convertYearsToMonthsWord = (year) => {
  switch (year) {
    case 1:
      return 'twelve';
    case 2:
      return 'twenty_four';
    case 3:
      return 'thirty_six';
    case 4:
      return 'fourty_eight';
    case 5:
      return 'sixty';
    default:
      return year;
  }
};

const convertYearsToMonths = (year) => {
  return year * 12;
};

const convertYearsToWeeks = (year) => {
  return year * 52;
};

export { convertYearsToMonthsWord, convertYearsToMonths, convertYearsToWeeks };
